import { Component, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { isPresent, chartTypeOptions, Weekoptions } from 'src/app/utils/utils';
import { CommonService } from 'src/app/services/common-service/common.service';
import { Labels } from 'src/app/constants/labels';
import { KEYS } from 'src/app/constants/keys';
import { API } from 'src/app/constants/api';
import { NgSelectComponent } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-dashboard-page',
  imports: [CommonModule, NgSelectComponent,SharedModule],
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss']
})
export class DashboardPageComponent implements OnInit {

  dashboardTemplateForm: FormGroup | any;
  templateId = "";
  isSuperaDmin: boolean = false;
  dbPath: any;
  dashboardChartData: any;
  messageLabel = Labels.messages;
  chartTypeOptions = chartTypeOptions;
  Opportunity: string = '';
  empasidebox: any =
    [{ name: "Profile Details", id: "Profile Details" }, { name: "Absent Employee", id: "Absent Employee" }];
  empasidebox2: any;
  empasidebox1: any;
  timesheetweek: any = 1;
  timeoutweek: any = 1;
  Weekoptiontype: any = Weekoptions;
  Contact = 'Contact';
  constructor(private formBuilder: FormBuilder,
    private commonService: CommonService,
    private toastr: ToastrService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.isSuperAdmin();
    this.refreshTableData();
    this.commonService.getDataFromTable(API.dashboardStaticTables.dashboard_emp_absent_employees).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
    });
    this.route.queryParams.subscribe(params => {
      const details = params['Details'];
      this.initPageForm(JSON.parse(details));

    });
    this.Opportunity = 'Opportunity';
  }
  ngOnChanges(changes: SimpleChanges): void {
  }
  refreshTableData() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.refreshDBoard(dbFullPath).subscribe(() => { });
  }
  isSuperAdmin() {
    const sessionSuperAdmin = sessionStorage.getItem(KEYS.isSuperAdmin);
    if (sessionSuperAdmin)
      this.isSuperaDmin = JSON.parse(sessionSuperAdmin);
    if (this.isSuperaDmin) {
      const sessionCustomerPath = sessionStorage.getItem(KEYS.customerDbPath);
      if (sessionCustomerPath)
        this.dbPath = JSON.parse(sessionCustomerPath);
    }
  }
  getDashboardChartData(dashboardId: any) {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    const defaultChart = 'columnChart';
    this.commonService.loadDashboardChartData(dbFullPath, dashboardId).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      const dashboardChartData = data['table'];
      this.dashboardTemplateForm.patchValue({
        chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        crm_chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        crm_chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        crm_chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        crm_chartBlock4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4'))[0]['gstibo_chart_type'] : defaultChart),
        crm_chartBlock5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5'))[0]['gstibo_chart_type'] : defaultChart),
        crm_chartBlock6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock6'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock1_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock2_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        chartBlock3_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        crm_chartBlock1_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        crm_chartBlock2_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        crm_chartBlock3_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        crm_chartBlock4_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        crm_chartBlock5_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        crm_chartBlock6_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_chartBlock6'))[0]['gstibo_chart_heading'] : ''),
        crm_staticBlock1_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'crm_staticBlock1'))[0]['gstibo_chart_heading'] : ''),
        staticBlock1_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'staticBlock1'))[0]['gstibo_chart_heading'] : ''),
        chartBlock4: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock5: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock6: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock7: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_type'] : defaultChart),
        chartBlock4_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock4'))[0]['gstibo_chart_heading'] : ''),
        chartBlock5_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock5'))[0]['gstibo_chart_heading'] : ''),
        chartBlock6_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock6'))[0]['gstibo_chart_heading'] : ''),
        chartBlock7_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'chartBlock7'))[0]['gstibo_chart_heading'] : ''),

        cust_chartBlock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock1'))[0]['gstibo_chart_type'] : defaultChart),
        cust_chartBlock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock2'))[0]['gstibo_chart_type'] : defaultChart),
        cust_chartBlock3: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock3'))[0]['gstibo_chart_type'] : defaultChart),
        cust_chartBlock1_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock1'))[0]['gstibo_chart_heading'] : ''),
        cust_chartBlock2_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock2'))[0]['gstibo_chart_heading'] : ''),
        cust_chartBlock3_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock3')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_chartBlock3'))[0]['gstibo_chart_heading'] : ''),
        cust_staticBlock1_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_staticBlock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'cust_staticBlock1'))[0]['gstibo_chart_heading'] : ''),
        emp_asideblock1: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock1'))[0]['gstibo_chart_heading'] : 'Profile Details'),
        emp_asideblock1_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock1')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock1'))[0]['gstibo_chart_heading'] : ''),
        emp_asideblock2: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock2'))[0]['gstibo_chart_heading'] : 'Absent Employee'),
        emp_asideblock2_heading: (isPresent(dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock2')) ? (dashboardChartData.filter((x: any) => x.gstibo_chart_block_id == 'emp_asideblock2'))[0]['gstibo_chart_heading'] : ''),
      });
      this.empasidebox1 = this.dashboardTemplateForm.controls.emp_asideblock1_heading.value;
      this.empasidebox2 = this.dashboardTemplateForm.controls.emp_asideblock2.value;
      this.commonService.ogLog('this.empasidebox1', this.empasidebox2);
    });

  }
  initPageForm(details: any) {
    this.dashboardTemplateForm = this.formBuilder.group({
      dashboardId: details['gstibo_dashboard_id'],
      templateId: [details['gstibo_template_id'], Validators.required],
      templateCode: [details['gstibo_template_code'], Validators.required],
      moduleId: [details['gstibo_module_id'], Validators.required],
      chartBlock1: ['columnChart'],
      chartBlock2: ['columnChart'],
      chartBlock3: ['columnChart'],
      crm_chartBlock1: ['columnChart'],
      crm_chartBlock2: ['columnChart'],
      crm_chartBlock3: ['columnChart'],
      crm_chartBlock4: ['columnChart'],
      crm_chartBlock5: ['columnChart'],
      crm_chartBlock6: ['columnChart'],
      chartBlock1_heading: null,
      chartBlock2_heading: null,
      chartBlock3_heading: null,
      crm_chartBlock1_heading: null,
      crm_chartBlock2_heading: null,
      crm_chartBlock3_heading: null,
      crm_chartBlock4_heading: null,
      crm_chartBlock5_heading: null,
      crm_chartBlock6_heading: null,
      crm_staticBlock1_heading: null,
      staticBlock1_heading: null,
      chartBlock4: null,
      chartBlock5: null,
      chartBlock6: null,
      chartBlock7: null,
      chartBlock4_heading: null,
      chartBlock5_heading: null,
      chartBlock6_heading: null,
      chartBlock7_heading: null,

      cust_chartBlock1: ['columnChart'],
      cust_chartBlock2: ['columnChart'],
      cust_chartBlock3: ['columnChart'],
      cust_chartBlock1_heading: null,
      cust_chartBlock2_heading: null,
      cust_chartBlock3_heading: null,
      cust_staticBlock1_heading: null,
      emp_asideblock1: ['Profile Details'],
      emp_asideblock1_heading: null,
      emp_asideblock2: ['Absent Employee'],
      emp_asideblock2_heading: null
    });
    this.getDashboardChartData(details['gstibo_dashboard_id']);

  }
  /*drpChangeEvent(drop_value, chartBlock) {
    // if (chartBlock == 'chartBlock1') {
    //   this.dashboardTemplateForm.value.chartBlock1 = drop_value;
    // }
    // else if (chartBlock == 'chartBlock2') {
    //   this.dashboardTemplateForm.value.chartBlock2 = drop_value;
    // }
    // else if (chartBlock == 'chartBlock3') {
    //   this.dashboardTemplateForm.value.chartBlock3 = drop_value;
    // }
    // 
    // this.dashboardTemplateForm.patchValue({
    //   chartBlock: drop_value
    // });
  }**/
  updateChartType(chartBlock: any, chartBlockHeading: any) {

    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    let chartType = '', chartHeading = '';
    if (isPresent(this.dashboardTemplateForm.value[chartBlock])) {
      chartType = this.dashboardTemplateForm.value[chartBlock];
    }
    chartHeading = this.dashboardTemplateForm.value[chartBlockHeading];
    this.commonService.saveUpdateDashboardChartType(dbFullPath, this.dashboardTemplateForm.value.dashboardId, chartBlock, chartType, chartHeading).subscribe(() => {
    //  this.toastr.success(this.messageLabel.save_success_msg.message);
     this.commonService.showModalValidate(this.messageLabel.save_success_msg.message,'',this.messageLabel.static_messages.info,this.messageLabel.save_success_msg.message);
    });
  }

  updateAsideboxType(chartBlock: any, chartBlockHeading: any) {

    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    let chartType = 'Asidebox', chartHeading = '';
    // if (isPresent(this.dashboardTemplateForm.value[chartBlock])) {
    //   chartType = this.dashboardTemplateForm.value[chartBlock];
    // }
    chartHeading = this.dashboardTemplateForm.value[chartBlockHeading];
    this.commonService.saveUpdateDashboardChartType(dbFullPath, this.dashboardTemplateForm.value.dashboardId, chartBlock, chartType, chartHeading).subscribe(() => {
      //this.toastr.success(this.messageLabel.save_success_msg.message);
      this.commonService.showModalValidate(this.messageLabel.save_success_msg.message,'',this.messageLabel.static_messages.info,this.messageLabel.save_success_msg.message);
      this.getDashboardChartData(this.dashboardTemplateForm.value.dashboardId);
    });
  }
  ontimesheetweekchange(e: any) {
    this.timesheetweek = e.target.value;
  }
  ontimeoutweekchange(e: any) {
    this.timeoutweek = e.target.value;
  }

}
